import React, { useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../profile/profile.css";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Userlist = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Redirect if not logged in
    if (!user) {
      navigate("/login");
      return;
    }

    // Fetch all users from backend
    const fetchUsers = async () => {
      try {
        const res = await fetch("https://vortexnetowrknew.co.uk/php-backend/get_users.php");
        const data = await res.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [user, navigate]);

  if (loading) return <div className="loading">Loading users...</div>;

  return (
    <div className="userlist-container">
      <h1 className="userlist-title">
        <i className="fas fa-users"></i> Registered Users
      </h1>

      {users.length === 0 ? (
        <p className="no-users">No users found.</p>
      ) : (
        <table className="userlist-table">
          <thead>
            <tr>
              <th><i className="fas fa-id-badge"></i> ID</th>
              <th><i className="fas fa-user"></i> Username</th>
              {/* <th><i className="fas fa-envelope"></i> Email</th> */}
              <th><i className="fas fa-calendar-alt"></i> Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.id}</td>
                <td>{u.username}</td>
                {/* <td>{u.email}</td> */}
                <td>{u.created_at}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Userlist;
